import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';

type SpotlightPulseWrapperChildren = React.PropsWithChildren<any> | null;

export const CreateButtonSpotlightPulseWrapper = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_ACTIVATION,
})(
	({
		condition,
		wrapper,
		children,
	}: {
		condition: boolean;
		wrapper: (children: SpotlightPulseWrapperChildren) => SpotlightPulseWrapperChildren;
		children: SpotlightPulseWrapperChildren;
	}) => (condition ? wrapper(children) : children),
);
